// extracted by mini-css-extract-plugin
export default {"cls1":"ruuaYv07od27NZf_VOkU","cls2":"xGQEkMxDQjKlCbx6XAVP ruuaYv07od27NZf_VOkU"};